export default __webpack_public_path__ + "static/media/rochLogo.f235b18c.png";